import { render, staticRenderFns } from "./PresentationFigures.vue?vue&type=template&id=49d38da6"
import script from "./PresentationFigures.vue?vue&type=script&lang=ts"
export * from "./PresentationFigures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports